/**
 * A small spinner for inside a button while its request is in flight. Drawn
 * in the button's own text colour, so it suits dark and light buttons alike.
 */
const ButtonSpinner = () => (
  <span
    aria-hidden="true"
    className="inline-block h-[12px] w-[12px] shrink-0 animate-spin rounded-full border-2 border-current border-t-transparent"
  />
);

export default ButtonSpinner;
